import { Observable, of } from 'rxjs';
import { NotificationService } from './notification.service';

export class BaseService {
  constructor(protected notificationService: NotificationService) {}

  protected handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO send the error to remote logging infrastructure
      console.error(error);

      this.notificationService.notify(
        `${operation} failed: ${error.message}`,
        false
      );

      return of(result as T);
    };
  }
}
